"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentAccountData = exports.SalesData = void 0;
var ts_money_1 = require("ts-money");
var CategoryValue_1 = __importDefault(require("./CategoryValue"));
var Promo_1 = require("./Promo");
var Dashboard = /** @class */ (function () {
    function Dashboard(json) {
        this.invoiceStats = {
            paidCount: json.invoiceStats.paidCount,
            unpaidCount: json.invoiceStats.unpaidCount,
            totalPaidSalesAmount: ts_money_1.Money.fromInteger(json.invoiceStats.totalPaidSalesAmount, 'MYR'),
            totalUnpaidSalesAmount: ts_money_1.Money.fromInteger(json.invoiceStats.totalUnpaidSalesAmount, 'MYR'),
            uniqueCustomers: json.invoiceStats.uniqueCustomers,
            newCustomers: json.invoiceStats.newCustomers,
            topProducts: json.invoiceStats.topProducts.map(function (pqJson) { return new Promo_1.ProductQuantity(pqJson); }),
            categoryRevenue: json.invoiceStats.categoryRevenue.map(function (crJson) { return new CategoryValue_1.default(crJson); }),
            timeSeries: json.invoiceStats.timeSeries.map(function (tsJson) { return new SalesData(tsJson); }),
        };
        this.paymentStats = {
            transactionCount: json.paymentStats.transactionCount,
            totalPaymentAmount: ts_money_1.Money.fromInteger(json.paymentStats.totalPaymentAmount, 'MYR'),
            paymentAccountValues: json.paymentStats.paymentAccountValues.map(function (pbmJson) { return new PaymentAccountData(pbmJson); })
        };
    }
    Object.defineProperty(Dashboard.prototype, Symbol.toStringTag, {
        get: function () {
            return 'Dashboard';
        },
        enumerable: false,
        configurable: true
    });
    return Dashboard;
}());
exports.default = Dashboard;
var SalesData = /** @class */ (function () {
    function SalesData(json) {
        this.time = new Date(json.time);
        this.grossTotal = ts_money_1.Money.fromInteger(json.grossTotalAmount, 'MYR');
        this.netTotal = ts_money_1.Money.fromInteger(json.netTotalAmount, 'MYR');
        this.invoiceCount = json.invoiceCount;
    }
    return SalesData;
}());
exports.SalesData = SalesData;
var PaymentAccountData = /** @class */ (function () {
    function PaymentAccountData(json) {
        this.paymentAccount = json.paymentAccount;
        this.amount = ts_money_1.Money.fromInteger(json.amount, 'MYR');
        this.count = json.count;
    }
    return PaymentAccountData;
}());
exports.PaymentAccountData = PaymentAccountData;
